import { getGlobalHeadersAsObject } from "../global-headers";

export const getGenericModel = (queryParams: URLSearchParams): Promise<any[]> => {
	const model = queryParams.get("model");
	if (!model) {
		throw new Error("Model must be specified.");
	}
	queryParams.delete("model");

	return fetch(`/api/v2/generic/${model}/?${queryParams.toString()}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => {
		if (!res.ok) {
			throw new Error(`Failed fetching data: ${res.status} ${res.statusText}`);
		}
		return res.json();
	});
};
